import React from "react";

const Error400 = () => {
  const handleBackToHomeClick = () => {
    window.location.href = `${process.env.PUBLIC_URL}/dashboard/`;
  };

  return (
    <>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Server Error</title>
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"
        integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm"
        crossOrigin="anonymous"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;400;700&display=swap"
        rel="stylesheet"
      />
      <style
        dangerouslySetInnerHTML={{
          __html: `
            body {
              overflow: hidden;
              font-family: 'Poppins', sans-serif;
            }
            .container-fluid {
              height: 560px;
            }
            .text1, .text2 {
              font-family: 'Poppins', sans-serif;
              color: #333;
            }
            .request {
              background-color: #F72B60;
              color: white;
              border: none;
              border-radius: 5px;
              font-size: 16px;
              padding: 10px 20px;
            }
            .request:hover {
              color: white;
            }
          `,
        }}
      />
      <div className="container-fluid">
        <img
          className="img1"
          src="https://demo.adgebra.in/custom/html/ResetPassword/1.png"
          style={{ position: "absolute", right: 0, top: "-20px", width: "20%" }}
          alt="Error Background 1"
        />
        <img
          className="img3"
          src="https://demo.adgebra.in/custom/html/ResetPassword/3.png"
          style={{ position: "absolute", top: 0, left: 75, width: "5%" }}
          alt="Error Background 2"
        />
        <div
          style={{
            width: "100%",
            position: "absolute",
            padding: 30,
            top: "27%",
            display: "grid",
            gridGap: 20,
          }}
        >
          <span
            className="text2"
            style={{ left: 30, lineHeight: 2, fontSize: 18 }}
          >
            500 Internal Server Error
          </span>
          <span className="text1" style={{ left: 30 }}>
            Oops! Something went wrong.
          </span>
          <span
            className="text2"
            style={{ left: 30, lineHeight: 2, fontSize: 18 }}
          >
            The server encountered an error and could not complete your request.{" "}
            <br />
            Please try again later, or contact{" "}
            <a href="mailto:products@inuxu.media">support</a> if the problem
            persists.
          </span>
          <button className="request" onClick={handleBackToHomeClick}>
            <i
              className="fa fa-angle-left"
              style={{
                position: "relative",
                marginRight: 8,
                fontSize: 22,
              }}
            />
            Back to home
          </button>
        </div>
      </div>
    </>
  );
};

export default Error400;
